import axios from 'axios';

const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

export default class UsersService {
  // `user.address` llega ya armada (address.utils toAddressPayload) u omitida si no se cargó.
  static async createUser(user) {
    const data = {
      role: user.role,
      email: user.email,
      name: user.name,
      surname: user.surname,
      country: user.country
    };
    if (user.address) {
      data.address = user.address;
    }
    if (user.birthday != null) {
      data.birthday = new Date(user.birthday).toISOString();
    }
    if (user.rut != null) {
      data.rut = user.rut;
    }
    if (user.serial != null) {
      data.serial = user.serial;
    }
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.post(`${ADMIN_URL}/users`, data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        console.log(response.data.data);
        return { status: 'ok', data: response.data.data };
      } else {
        return { status: 'error', message: response.data.message };
      }
    } catch (error) {
      console.log(`POST ${ADMIN_URL}/users`);
      return { status: 'error', message: error.response?.data?.message || error.message };
    }
  }

  static async getUsers(page, limit, search) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      let url = `${ADMIN_URL}/users?page=${page}&limit=${limit}`;
      if (search != null && search.length != 0) {
        url = url + `&search=${search}`;
      }
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      } else {
        return { status: 'error' };
      }
    } catch (error) {
      return { status: 'error' };
    }
  }

  static async getUserById(userId) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.get(`${ADMIN_URL}/users/${userId}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      } else {
        return { status: 'error' };
      }
    } catch (error) {
      return { status: 'error' };
    }
  }

  // `user.address` solo viene si la dirección cambió: sin la clave, el backend
  // conserva la dirección guardada (y no valida la de México).
  static async updateUser(user) {
  const data = {
    role: user.role,
    email: user.email,
    name: user.name,
    surname: user.surname,
    country: user.country,
    rut: user.rut,
    serial: user.serial,
    phone: user.phone,
    isVip: user.isVip
  };
  if (user.address) {
    data.address = user.address;
  }
  if (user.birthday) {
    let birthdayDate;
    if (typeof user.birthday === 'string' && user.birthday.match(/^\d{4}-\d{2}-\d{2}$/)) {
      const [year, month, day] = user.birthday.split('-');
      birthdayDate = new Date(Date.UTC(parseInt(year), parseInt(month) - 1, parseInt(day), 23, 59, 59));
    } 
    else {
      birthdayDate = new Date(user.birthday);
    }
    if (!isNaN(birthdayDate.getTime())) {
      data.birthday = birthdayDate.toISOString();
    }
  }
  try {
    const accessToken = JSON.parse(localStorage.getItem('accessToken'));
    const response = await axios.put(`${ADMIN_URL}/users/${user.id}`, data, {
      headers: { Authorization: `Bearer ${accessToken}` }
    });
    if (response.data.status === 'ok') {
      return { status: 'ok', data: response.data.data };
    } else {
      return { status: 'error', message: response.data.message };
    }
  } catch (error) {
    return { status: 'error', message: error.response?.data?.message || error.message };
  }
}

  //! V2 - PostgreSQL users
  static async getUsersBySearch(search) {
    const accessToken = JSON.parse(localStorage.getItem('accessToken'));
    const response = await axios.get(`${ADMIN_URL}/users/details?search=${search}`, {
      headers: { Authorization: `Bearer ${accessToken}` }
    });
    if (response.data.status === 'ok') {
      return { status: 'ok', data: response.data.data };
    } else {
      throw new Error(response.data.message);
    }
  }

  static async getUsersBySearchToRefund(params) {
    const accessToken = JSON.parse(localStorage.getItem('accessToken'));
    const response = await axios.get(`${ADMIN_URL}/users/params?params=${params}`, {
      headers: { Authorization: `Bearer ${accessToken}` }
    });
    if (response.data.status === 'ok') {
      return { status: 'ok', data: response.data.data };
    } else {
      throw new Error(response.data.message);
    }
  }

  static async getCoTutorsByUser(userId) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.get(`${ADMIN_URL}/co-tutors/${userId}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      return { status: 'ok', data: response.data.data };
    } catch {
      return { status: 'error' };
    }
  }

  static async addCoTutor(userId, payload) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.post(`${ADMIN_URL}/co-tutors/${userId}`, payload, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      return { status: 'ok', data: response.data.data };
    } catch {
      return { status: 'error' };
    }
  }

  // Unified manual user creation (admin panel) — the backend decides which
  // creation strategy to run (B2C or B2B) based on `type`.
  static async createManualUser(type, payload) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const data = { type, ...payload };
      const response = await axios.post(`${ADMIN_URL}/users/form/create-user/new`, data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });

      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      } else {
        return { status: 'error', message: response.data.message };
      }
    } catch (error) {
      console.error(`POST ${ADMIN_URL}/users/form/create-user/new`, error);
      // El backend siempre responde errores como { status: 'error', message, httpCode }
      // (ver server-configuration.middleware.ts) — leerlo en vez de error.message (Axios
      // devuelve un texto genérico tipo "Request failed with status code 409" que no sirve
      // para distinguir la causa real del error, ej. RUT inválido vs. clínica ya existente).
      return {
        status: 'error',
        message: error.response?.data?.message ?? error.message,
        httpCode: error.response?.status
      };
    }
  }

  static async getIdentityStatus(userId) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.get(`${ADMIN_URL}/users/360/user-data/${userId}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        const { identityValidatedAt } = response.data.data;
        return { status: 'ok', data: { identityValidatedAt } };
      } else {
        return { status: 'error' };
      }
    } catch (error) {
      return { status: 'error' };
    }
  }

  static async validateIdentity(userId) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.post(
        `${ADMIN_URL}/users/360/validate-identity/${userId}`,
        {},
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      if (response.data.status === 'ok') {
        return { status: 'ok' };
      } else {
        return { status: 'error' };
      }
    } catch (error) {
      return { status: 'error' };
    }
  }

  static async createB2BUser(newUser, planId, companyId, contratoId, totalAccounts, extraInfo) {
    try {
      const data = {
        name: newUser.name,
        surname: newUser.surname,
        email: newUser.email,
        rut: newUser.rut,
        type: 'b2b',
        country: newUser.country,
        countryIso: newUser.country,
        planId,
        companyId,
        ...(contratoId && { contratoId }),
        ...(totalAccounts !== null && totalAccounts !== undefined && { totalAccounts }),
        ...(extraInfo && { extraInfo })
      };
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.post(`${ADMIN_URL}/users/form/create-user/new`, data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });

      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.user };
      } else {
        return { status: 'error', message: response.data.message };
      }
    } catch (error) {
      console.error(`POST ${ADMIN_URL}/users/form/create-user/new`, error);
      return { status: 'error', message: error.message };
    }
  }
}
